var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubSportCircleWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.572632,
    y: 1.15625,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.572632,
    y: 1.15625,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9605 31.612C28.9473 31.612 27.3143 29.9946 27.3143 27.9992C27.3143 26.0037 28.9468 24.3858 30.9605 24.3858C32.9742 24.3858 34.6077 26.0032 34.6077 27.9992C34.6077 29.9952 32.9752 31.612 30.9605 31.612ZM32.0526 21.043L32.0526 17.8262C32.4797 17.6304 32.842 17.3164 33.097 16.9214C33.3519 16.5263 33.4889 16.0665 33.4918 15.5961L33.4918 15.5218C33.4918 14.1623 32.3691 13.0506 30.9984 13.0506L30.9231 13.0506C29.5539 13.0506 28.4297 14.1628 28.4297 15.5218L28.4297 15.5961C28.4327 16.0665 28.5697 16.5262 28.8246 16.9212C29.0796 17.3163 29.4418 17.6303 29.8688 17.8262L29.8688 21.043C28.6393 21.2288 27.4798 21.734 26.506 22.5085L17.6013 15.6441C17.6637 15.4183 17.6971 15.1854 17.7009 14.9512C17.7009 13.4108 16.4428 12.1605 14.8889 12.1563C13.3349 12.152 12.0742 13.4003 12.0726 14.9411C12.0711 16.482 13.3286 17.7297 14.8825 17.7324C15.3693 17.7303 15.8471 17.6014 16.2691 17.3585L25.0305 24.1137C24.2423 25.2894 23.8305 26.6778 23.85 28.0937C23.8695 29.5097 24.3193 30.8861 25.1395 32.0397L22.4739 34.6816C22.1585 34.5826 21.8255 34.5533 21.4977 34.5956C21.1699 34.6379 20.8552 34.7509 20.5752 34.9268C20.2952 35.1026 20.0566 35.3372 19.8758 35.6142C19.6951 35.8913 19.5764 36.2044 19.5281 36.5318C19.4798 36.8592 19.5029 37.1932 19.5959 37.5108C19.6889 37.8284 19.8496 38.122 20.0668 38.3715C20.284 38.6209 20.5527 38.8202 20.8542 38.9557C21.1558 39.0912 21.4831 39.1595 21.8136 39.1561C23.09 39.1561 24.1253 38.1299 24.1253 36.8648C24.123 36.6425 24.0875 36.4217 24.02 36.2099L26.6529 33.5985C27.8924 34.5393 29.4052 35.048 30.9605 35.0471C34.8894 35.0471 38.0726 31.892 38.0726 27.9992C38.0726 24.4755 35.4597 21.5656 32.0521 21.043",
    fill: "#FF7A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubSportCircleWhite);
export default __webpack_public_path__ + "static/media/HubSportCircleWhite.c040048b8f17ef4c9d26c3d638d87303.svg";
export { ForwardRef as ReactComponent };